import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background: black;\n    background: rgba(0, 0, 0, 0.7);\n    padding: 8px;\n    border-radius: 4px;\n    cursor: pointer;\n\n    ", " {\n        display: flex;\n        align-items: center;\n        color: white !important;\n        margin: 0;\n\n        ", " {\n            margin-right: 4px;\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Popover, Icon, Text } from '../../Atoms';
export var StyledCopyToClipboard = styled(Popover)(_templateObject(), Text.Styles.StyledText, Icon.Styles.StyledIcon);